export default __webpack_public_path__ + "static/media/PlusActive.76a0a5c1.svg";